import {
  OnInit,
  Directive,
  ElementRef,
  TemplateRef,
  ViewContainerRef,
  Input
} from '@angular/core';
import { AuthService } from '../services/auth.service';
import { PermissionsService } from '../services/permissions.service';

@Directive({
  selector: '[accountHasPermission]'
})
export class AccountHasPermissionDirective implements OnInit {

  @Input() set accountHasPermission(value: string | string[]) {
    this._accountAllowed(value);
  }

  private accountPermissions = [];
  private currentUser: any = {};
  private subscriptions: any = {};
  private hidden = true;

  constructor(
    private el: ElementRef,
    private templateRef: TemplateRef<any>,
    private viewRef: ViewContainerRef,
    private authService: AuthService,
    private permissionService: PermissionsService
  ) {

  }

  ngOnInit() { }

  ngOnDestroy() {
    Object.keys(this.subscriptions).forEach((key) => {
      this.subscriptions[key].unsubscribe();
    });
  }

  /**
   * Get value from directive to check if user have permission for that section
   * @param val array of permissions
   */
  private _accountAllowed(val) {
    this.accountPermissions = val || [];
    this.subscriptions.currentContract = this.authService.currentUser.subscribe(data => {
      this.currentUser = data || {};
      if (!this.currentUser.accounts)
        return this.updateView(this.accountPermissions, this.currentUser.permissions);

      const account = this.currentUser.accounts
        .find(x => this.authService.accountId.toString() === x.accountId.toString());

      this.currentUser.permissions = account ? account.accountPermissions : [];
      this.updateView(this.accountPermissions, this.currentUser.permissions);
    });
  }

  /**
   * Display or hide an element depending of user permissions
   * @param sectionPermissions section to check if have permissions
   * @param userPemissions user list of permissions
   */
  private updateView(sectionPermissions: any, userPemissions: any) {
    if (this.permissionService.checkPermissions(sectionPermissions, userPemissions)) {
      if (this.hidden) {
        this.viewRef.createEmbeddedView(this.templateRef);
        this.hidden = false;
      }
    } else {
      this.hidden = true;
      this.viewRef.clear();
    }

  }


}
